import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import { getMessage, mapStateToProps } from '../../common/message/Message';

@connect(mapStateToProps)
class Alert extends React.Component {
    static propTypes = {
        message: PropTypes.any,
        messageCode: PropTypes.string,
        severity: PropTypes.string,
        customClassNames: PropTypes.string,
        show: PropTypes.bool,
        closeable: PropTypes.bool,
        closeAction: PropTypes.func,
        messages: PropTypes.object
    };

    static defaultProps = {
        message: '',
        severity: '',
        customClassNames: '',
        show: false,
        closeable: false,
        closeAction: () => {}
    };

    state = {
        show: true
    };

    onClose = _ => this.props.closeAction();

    render() {
        const {
            customClassNames,
            severity,
            closeable,
            message,
            messageCode,
            show,
            messages
        } = this.props;
        const props = this.props;
        if (!show) {
            return (
                <div />
            );
        }
        const iconClasses = classNames('alert-info-icon', 'enterprise-icon-information',
            { 'enterprise-icon-check_circle': severity === 'success', 'enterprise-icon-warning-outline': severity === 'danger' });
        const alertClasses = classNames('alert', `alert-${severity}`);
        const messageClasses = classNames('message message-col', { 'col-xs-10': closeable, 'col-xs-11': !closeable });
        const alertMessage = message || getMessage(messages, messageCode);
        return (
            <div className={`alert-container ${customClassNames}`}>
                <div className={alertClasses}>
                    <div className="row">
                        <div className="text-center icon-col icon-container">
                            <i className={iconClasses} />
                        </div>
                        <div className="col-sm-1 col-xs-1" />
                        <div className={messageClasses}>
                            <p dangerouslySetInnerHTML={{ __html: alertMessage }} />
                        </div>
                        {!props.closeable ? '' : (
                            <button
                                type="button"
                                className="col-xs-1 icon-col close"
                                onClick={this.onClose}
                                aria-label="Close">
                                <i className="glyphicon enterprise-icon-close" />
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Alert;
